<template>
  <el-dialog
    id="SampleLogistics"
    title="物流信息"
    width="700px"
    :visible.sync="visible">
    <el-row>
      <el-col :span="24">
        运输公司：{{data.courierCo}}
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        物流编号：{{data.courierNum}}
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        预计收样时间：{{data.receiveTime}}
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        预计送样时间：{{data.sendTime}}
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'sample-logistics-info',
    data() {
      return {
        visible: false,
        data: {}
      }
    },
    methods: {
      init (id) {
        axios.get("/jys/hospSample/getCourier/" + id
        ).then(res => {
          if(res.data.code == 0){
            let sampleCourier = res.data.sampleCourier
            this.data = {
              courierCo: sampleCourier.courierCo?sampleCourier.courierCo:'-',
              courierNum: sampleCourier.courierNum?sampleCourier.courierNum:'-',
              receiveTime: sampleCourier.receiveTime?sampleCourier.receiveTime:'-',
              sendTime: sampleCourier.sendTime?sampleCourier.sendTime:'-'
            }
            this.visible = true
          }
        });
      }
    }
  }
</script>

<style scoped>
  #SampleLogistics >>> .el-dialog__header{
    text-align: center;
  }
  #SampleLogistics >>> .el-dialog__title{
    color: #000000;
    font-size: 17px;
  }
  #SampleLogistics >>> .el-dialog__body{
    padding: 20px 5%;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/sample-logistics-info.vue